exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-tooltip .ivu-tooltip-popper{top:0!important;width:320px}", ""]);

// exports
